import React from "react";
import { Award, Medal, Star, Trophy } from "lucide-react";
import { useContent } from "../context/ContentContext";

const iconFor = (idx) => {
  const icons = [Trophy, Medal, Star, Award];
  const I = icons[idx % icons.length];
  return <I className="w-5 h-5 text-red-500" />;
};

const Accolades = () => {
  const { accolades } = useContent();
  return (
    <section id="accolades" className="relative py-24 md:py-32 bg-black border-t border-neutral-900">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="mb-14">
          <div className="flex items-center gap-3 mb-4">
            <span className="accent-bar" />
            <span className="text-xs uppercase tracking-[0.35em] text-neutral-400 font-heading">
              04 — Accolades
            </span>
          </div>
          <h2 className="font-display text-5xl md:text-6xl text-white leading-none">
            EARNED <span className="text-red-600">NOT GIVEN</span>
          </h2>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-neutral-800" />
          <ul className="space-y-10">
            {accolades.map((a, idx) => (
              <li
                key={a.title}
                className={`relative grid md:grid-cols-2 gap-6 ${
                  idx % 2 === 0 ? "" : "md:[direction:rtl]"
                }`}
              >
                <div className="md:[direction:ltr] pl-12 md:pl-0 md:pr-10">
                  <div className="stat-card border border-neutral-800 bg-neutral-900/50 rounded-sm p-6">
                    <div className="flex items-center gap-3 mb-2">
                      <span className="w-9 h-9 rounded-sm bg-red-600/10 border border-red-600/30 flex items-center justify-center">
                        {iconFor(idx)}
                      </span>
                      <span className="text-[10px] uppercase tracking-[0.3em] text-red-500 font-heading">
                        {a.year}
                      </span>
                    </div>
                    <h3 className="font-display text-2xl text-white leading-tight">
                      {a.title}
                    </h3>
                    <p className="mt-2 text-neutral-400 text-sm">
                      {a.description}
                    </p>
                  </div>
                </div>
                <div className="hidden md:block" />
                <span className="absolute left-4 md:left-1/2 top-6 -translate-x-1/2 w-3 h-3 rounded-full bg-red-600 ring-4 ring-black" />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Accolades;
